<ng-container *ngIf="policy$ | async as policy">
  <ws-plan-picker
    [policy]="policy"
    [staffView]="staffView === true"
    [sessionTermId]="session.policyTermId"
    [formControl]="planControl"
    [evaluatedPlans]="(evaluatedPlans$ | async)?.evaluatedPlans"
    [viewablePlansAndTerms]="session.viewablePlansAndTerms"
    [planMarkups]="(planMarkups$ | async) ?? {}"
    [hideMarkupEntry]="(hideMarkupEntry$ | async) === true"
    (back)="goBack()"
    (buyNow)="next()"
    (addons)="addons.emit($event)"
    (termChanged)="termChanged.emit($event)"
    (markupChanged)="onMarkupChanged($event)"
  ></ws-plan-picker>
</ng-container>
